import { GetBulkAppointmentsParams } from "../utils/bridges/DummyBridge";
import { serializeErrorForTracking, track } from "../utils/tracking";
import { bulkGetAppointments } from "./appointments/bulk-get";
import { bulkPutAppointments } from "./appointments/bulk-put";
import { bulkGetPaitnets } from "./patients/bulk-get";
import {
  getAptBillStatusForQueue,
  normalizeReceiptPaymentStatus,
} from "./receipts/receiptMappingWithAppointment";
import { enrichAppointmentsWithPatientData } from "./patients/patientMappingWithAppointmentAndReceipt";
import { Appointment } from "@elixir/types";
import { getActiveAppointmentsOnly } from "./appointments/filter-active-appointments";

export { getAptBillStatusForQueue };

export const FetchAppointmentsAndPatientsController = async (
  params: GetBulkAppointmentsParams
) => {
  try {
    const appointments = await bulkGetAppointments(params);
    const activeAppointmentsOnly = getActiveAppointmentsOnly(appointments);
    const patientOids = Array.from(
      new Set(activeAppointmentsOnly.map((a) => a.patient_oid))
    );

    const patients = await bulkGetPaitnets(patientOids);

    const appointmentsWithNormalizedReceipts = activeAppointmentsOnly.map(
      normalizeReceiptPaymentStatus
    );

    const enrichedAppointments = enrichAppointmentsWithPatientData(
      appointmentsWithNormalizedReceipts,
      patients!
    );

    await bulkPutAppointments(enrichedAppointments);

    return {
      success: true,
      response: {
        //@ts-ignore
        apt: enrichedAppointments as Appointment[],
      },
    };
  } catch (e: any) {
    track("ERROR", {
      on: "FETCH_APPOINTMENTS_AND_PATIENTS",
      what: serializeErrorForTracking(e),
    });
    return {
      success: false,
    };
  }
};
